export const CONVERSION_QUERY_KEYS = {
  CURRENCY_EXCHANGE: 'CURRENCY_EXCHANGE',
};

export const EXCHANGE_TYPES = {
  EXCHANGE_CAPCONTA_TO_CAPWALLET: 'EXCHANGE_CAPCONTA_TO_CAPWALLET',
  EXCHANGE_CAPWALLET_TO_CAPCONTA: 'EXCHANGE_CAPWALLET_TO_CAPCONTA',
  EXCHANGE_CAPWALLET_TO_CAPWALLET: 'EXCHANGE_CAPWALLET_TO_CAPWALLET',
};
